import { connect } from 'react-redux'
// import { toggleTodo } from '../actions'
import Items from '../components/Items';

const mapStateToProps = ({ sculptures: { items }, activeButton, activeId }) => {

  return { items: items.filter(({ type, creator, author, filterType }) =>
      (type === activeButton)
      || (creator === activeButton)
      || (author === activeButton)
      || (filterType === activeButton)
      ), activeId };

  // return ({ items })
}

export default connect(
  mapStateToProps,
)(Items)
